<template lang="html">
<div>
  <Inmobiliaria v-if="inmobiliaria"></Inmobiliaria>
  <!-- <HomeInmo v-if="inmobiliaria"></HomeInmo> -->
  <Soc :guid=guid v-if="soc"></Soc>
</div>
</template>
<script>
import Inmobiliaria from '@/views/Inmobiliaria.vue'
import HomeInmo from '@/views/CasoInmobiliaria/nuevasVistas/Home.vue'
import Soc from '@/views/Soc.vue'
export default {
  props: {
    guid: {
      type: String,
      required: false
    },
  },
  components: {
    Inmobiliaria,
    HomeInmo,
    Soc
  },
  data(){
		return{
      soc:false,
      inmobiliaria:false
		}
  },
  created() {
    if (this.guid) {
      // Multilogin: solo LoadingPage autentica (evita carrera Soc → /login mientras carga)
      localStorage.setItem('multiLoginLoading', true)
      this.$router.replace({ name: 'loading', query: { guid: this.guid } }).catch(() => {})
    }
  },
  mounted() {
    // Con guid no montar Soc: la sesión y el redirect a / los completa /loading
    if (this.guid) return

    const tipoEjecutivoV3 = this.$store.state.AppActiveUser.TipoEjecutivoV3

    if ( tipoEjecutivoV3 === 'Inmo' ) return this.$router.push("/homeInmo").catch(() => {})

    this.soc = true
  }
}
</script>
